import { render, staticRenderFns } from "./RenameTrdocModal.vue?vue&type=template&id=2c5dd527&scoped=true"
import script from "./RenameTrdocModal.vue?vue&type=script&lang=js"
export * from "./RenameTrdocModal.vue?vue&type=script&lang=js"
import style0 from "./RenameTrdocModal.vue?vue&type=style&index=0&id=2c5dd527&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5dd527",
  null
  
)

export default component.exports